<template>
  <!-- Session Expired -->
  <div class="main-wrapper">
    <div class="container">
      <!-- Header -->
      <div class="authentication-header">
        <div class="container">
          <div class="col-md-12">
            <div class="text-center">
              <img src="@/assets/img/logo.svg" alt="logo" />
            </div>
          </div>
        </div>
      </div>
      <!-- /Header -->

      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <div class="content">
          <div class="row">
            <div class="col-md-6 d-flex justify-content-center align-items-center">
              <div class="row justify-content-center align-items-center">
                <h1 class="display-6 mb-1 text-center">Your Session has expired</h1>
                <div class="col-md-9">
                  <p class="fs-14 text-center mb-3">
                    Please refresh the page. Don't worry, we kept all of your filters and
                    breakdowns in place.
                  </p>
                </div>
                <div class="d-flex justify-content-center">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-dark d-flex align-items-center"
                  >
                    <i class="ti ti-circle-arrow-left me-1"></i>Back to Home
                  </a>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="d-flex justify-content-center align-items-center">
                <img
                  src="@/assets/img/bg/session-expired.png"
                  alt="Session Expired"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- /Page Wrapper -->
    </div>
  </div>
  <!-- /Session Expired -->
</template>
